// Import JS files from Mindstyle Core plugin
import '../../../../plugins/wpg-mindstyle-core/src/assets/js/components/swiper';

// files from theme
import './main';
import './components/swiper-configurations';
import './plugins/woocommerce/shop-category-button-toggle';
import shopToggleCategories from './components/shop-toggle-categories';
import './components/recently-viewed-products';
import "./components/shop-category-menu";


// On loading the document execute a function:
document.addEventListener('DOMContentLoaded', () => {
    shopToggleCategories();
});